import Chart from 'chart.js/auto';
import def_day_lines, { xAxisConfig, tooltipCallbacks, enableTouchPan } from './graph_utils.js';

export default function graph_flux_solaire(ser, times, ff2d, delta){

  // times a n éléments, les données dérivées en ont n-1
  // (on calcule la différence entre deux échéances consécutives)
  const n = ff2d.length - 1;
  var ff  = new Array(n);   // couverture nuageuse
  var ff2 = new Array(n);   // flux solaire moyen dans l'intervalle
  // Note les données sont en Joule/m² accumulées depuis le début.
  // (data[i+1] - data[i]) = Joule/m² dans l'intervalle
  // 3600 * delta           = secondes dans l'intervalle
  // Le rapport donne les W/m² moyens.
  for(let i=0; i < n; i++){
    ff[i]  = ff2d[i][0];
    ff2[i] = Math.max(parseInt(ff2d[i+1][1]) - parseInt(ff2d[i][1]), 0.) / (3600. * delta);
  }

  const dataTimes = times.slice(0, n);

  var label = "Flux solaire moyen dans l'heure indiquée sur l'axe des x";
  if(parseInt(delta) > 1){
    label = "Flux solaire moyen dans les " + String(delta) + " heures suivant l'heure indiquée sur l'axe des x";
  }

  var ann = [];
  def_day_lines(times, ann);

  const dt = {
    datasets: [
      {
	label: label,
	data: dataTimes.map((t, i) => ({ x: t.getTime(), y: ff2[i] })),
	backgroundColor: 'rgb(235, 143, 52)',
	order: 1,
	yAxisID: 'y',
      },
      {
	label: 'Couverture nuageuse',
	data: dataTimes.map((t, i) => ({ x: t.getTime(), y: ff[i] })),
	borderColor: 'rgb(52, 85, 235)',
	type: 'line',
	lineTension: 0.3,
	order: 0,
	yAxisID: 'y1',
      }
    ]
  };

  const ctx = document.getElementById('id_series_canvas');
  if(ser.chart){
    ser.chart.destroy();
  }
  ser.chart = new Chart(ctx, {
    type: 'bar',
    data: dt,
    options: {
      maintainAspectRatio: false,
      animations: false,
      responsive: true,
      scales: {
	x: xAxisConfig(times),
	y: {
          type: 'linear',
          display: true,
          position: 'left',
	  title: {
	    display: true,
	    text: 'Flux solaire [W/m²]'
	  },
	  suggestedMax: 900
	},
	y1: {
          type: 'linear',
          display: true,
          position: 'right',
	  title: {
	    display: true,
	    text: 'Couverture nuageuse [%]'
	  },
          grid: {
            drawOnChartArea: false,
          },
	  min: 0,
	  max: 100
	}
      },
      plugins: {
	tooltip: { callbacks: tooltipCallbacks },
	annotation: {
	  annotations: ann
	},
	zoom: {
	  zoom: {
	    wheel: {
	      enabled: true
	    },
	    pinch: {
	      enabled: true
	    },
	    mode: "x",
	    speed: 100
	  },
	  pan: {
	    enabled: true,
	    mode: "x",
	    speed: 100
	  }
	}
      }
    }
  });
  enableTouchPan(ser.chart);
}
